import {
    createContext,
    PropsWithChildren,
    useContext,
    useReducer,
  } from "react";
  
  interface UIState {
    menuShowing: boolean;
  }
  const initalState: UIState = {
    menuShowing: false,
  };
  
  const UIStateContext = createContext(initalState);
  const UIDispatchContext = createContext<any>(null);
  
  interface Action {
    type: string;
    payload: any;
  }
  function reducer(state: UIState, action: Action) {
    switch (action.type) {
      case "TOGGLE_MENU_VISIBLE":
        return { ...state, menuShowing: !state.menuShowing };
    }
  }
  
  export default function UIProvider({ children }: PropsWithChildren<any>) {
    const [state, dispatch] = useReducer(reducer, initalState as never);
  
    return (
      <UIDispatchContext.Provider value={dispatch}>
        <UIStateContext.Provider value={state}>
          {children}
        </UIStateContext.Provider>
      </UIDispatchContext.Provider>
    );
  }
  
  export function useUIProviderState() {
    const ctx = useContext(UIStateContext);
    return ctx;
  }
  export function useUIProviderDispatch() {
    const ctx = useContext(UIDispatchContext);
    return ctx;
  }
  